import { render, staticRenderFns } from "./Succ.vue?vue&type=template&id=c46b4cb0&"
import script from "./Succ.vue?vue&type=script&lang=js&"
export * from "./Succ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports